<template>
  <div v-if="isdisplay" class="psg-overlay" @click.self="close">
    <div class="psg-dialog">

      <!-- Header -->
      <div class="psg-head">
        <div class="psg-head-left">
          <div class="psg-head-icon"><i class="ri-shopping-bag-3-line"></i></div>
          <div class="psg-head-txt">
            <span>Panier client Scan &amp; Go</span>
            <small>Contrôlez les articles avant de les ajouter au ticket</small>
          </div>
        </div>
        <button class="psg-close" @click="close" aria-label="Fermer">
          <i class="ri-close-line"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="psg-body">

        <!-- Alerte magasin -->
        <div v-if="nbautremagasin > 0" class="psg-alert psg-alert-warn">
          <i class="ri-store-2-line"></i>
          <span>
            {{ nbautremagasin }} article(s) proviennent d'un <strong>autre magasin</strong>.
            Vérifiez que ce panier a bien été constitué ici.
          </span>
        </div>

        <!-- Alerte introuvables -->
        <div v-if="nbintrouvable > 0" class="psg-alert psg-alert-err">
          <i class="ri-error-warning-line"></i>
          <span>
            {{ nbintrouvable }} code(s) sans article correspondant : à saisir manuellement.
          </span>
        </div>

        <!-- Tableau des lignes -->
        <div class="psg-table-wrap">
          <table class="psg-table">
            <thead>
            <tr>
              <th class="psg-th-chk">
                <input type="checkbox"
                       :checked="toutCoche"
                       :disabled="nbtrouvable === 0"
                       @change="basculerTout" />
              </th>
              <th>Article</th>
              <th class="psg-num">Qté</th>
              <th class="psg-num">PU</th>
              <th class="psg-num">Total</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(l, i) in lignes" :key="'sgl' + i"
                :class="['psg-tr', { 'psg-tr-err': !l.trouve, 'psg-tr-off': l.trouve && !l.retenue }]">
              <td class="psg-th-chk">
                <input type="checkbox" v-model="l.retenue" :disabled="!l.trouve" />
              </td>
              <td>
                <template v-if="l.trouve">
                  <div class="psg-lib">{{ l.article.libelle }}</div>
                  <div class="psg-badges">
                    <span class="psg-ean">{{ l.ean }}</span>
                    <span v-if="!l.magok" class="psg-badge psg-badge-warn">
                      <i class="ri-store-2-line"></i> Autre magasin
                    </span>
                    <span v-if="l.stockinsuffisant" class="psg-badge psg-badge-warn">
                      <i class="ri-stack-line"></i> Stock : {{ l.rstck }}
                    </span>
                  </div>
                </template>
                <template v-else>
                  <div class="psg-lib psg-lib-err">
                    <i class="ri-close-circle-line"></i> Article introuvable
                  </div>
                  <div class="psg-badges"><span class="psg-ean">{{ l.ean }}</span></div>
                </template>
              </td>
              <td class="psg-num psg-qte">{{ formatNumber2(l.qte) }}</td>
              <td class="psg-num">
                <template v-if="l.trouve">{{ currencyFormatDE(l.pu) }}</template>
                <template v-else>-</template>
              </td>
              <td class="psg-num psg-total-l">
                <template v-if="l.trouve">{{ currencyFormatDE(l.pu * l.qte) }}</template>
                <template v-else>-</template>
              </td>
            </tr>
            <tr v-if="lignes.length === 0">
              <td colspan="5" class="psg-vide">Panier vide</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- Récapitulatif -->
        <div class="psg-recap">
          <div class="psg-recap-row">
            <span>Articles retenus</span>
            <strong>{{ nbretenue }} / {{ lignes.length }}</strong>
          </div>
          <div class="psg-recap-row psg-recap-main">
            <span>TOTAL INDICATIF</span>
            <strong>{{ currencyFormatDE(totalretenu) }} F</strong>
          </div>
          <small class="psg-recap-note">
            <i class="ri-information-line"></i>
            Montant recalculé par la caisse. Il fait foi, quel que soit le total affiché sur le téléphone.
          </small>
        </div>

      </div>

      <!-- Footer -->
      <div class="psg-foot">
        <button class="psg-btn-sec" @click="close">Annuler</button>
        <button class="psg-btn-pri" @click="importer" :disabled="nbretenue === 0">
          <i class="ri-download-2-line"></i>
          Importer {{ nbretenue }} ligne(s)
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import { currencyFormatDE, FormatNumber } from "@/allfunction";

export default {
  /* eslint-disable */
  name: "modalpanierscango",

  data() {
    return {
      isdisplay: false,
      payload: {},
      lignes: [],
    };
  },

  computed: {
    nbtrouvable() {
      return this.lignes.filter(l => l.trouve).length;
    },
    nbintrouvable() {
      return this.lignes.filter(l => !l.trouve).length;
    },
    nbautremagasin() {
      return this.lignes.filter(l => l.trouve && !l.magok).length;
    },
    nbretenue() {
      return this.lignes.filter(l => l.trouve && l.retenue).length;
    },
    totalretenu() {
      return this.lignes
          .filter(l => l.trouve && l.retenue)
          .reduce((s, l) => s + (parseFloat(l.pu) || 0) * (parseFloat(l.qte) || 0), 0);
    },
    toutCoche() {
      return this.nbtrouvable > 0 && this.nbretenue === this.nbtrouvable;
    },
  },

  methods: {
    currencyFormatDE(p) { return currencyFormatDE(Number(p)); },
    formatNumber2(p) { return FormatNumber(Number(p)); },

    basculerTout(e) {
      const v = e.target.checked;
      this.lignes.forEach(l => { if (l.trouve) l.retenue = v; });
    },

    importer() {
      const retenues = this.lignes.filter(l => l.trouve && l.retenue);
      if (retenues.length === 0) return;
      this.$emit('importer', retenues);
      this.isdisplay = false;
    },

    close() {
      this.isdisplay = false;
    },

    show(payload, lignes) {
      this.payload = payload || {};
      /* Les lignes introuvables ne sont jamais retenues : rien à importer pour elles. */
      this.lignes = (lignes || []).map(l => ({ ...l, retenue: !!l.trouve }));
      this.isdisplay = true;
    },
  },

  mounted() {},
};
</script>

<style scoped>
/* ── Overlay ── */
.psg-overlay {
  position: fixed; inset: 0; z-index: 10030;
  background: rgba(0, 0, 0, .55);
  display: flex; align-items: center; justify-content: center;
  padding: 16px;
  font-family: 'Segoe UI', system-ui, sans-serif;
}

/* ── Dialog ── */
.psg-dialog {
  background: var(--surface); border: 1px solid var(--border);
  border-radius: 14px; width: min(720px, 100%); max-height: 90vh;
  display: flex; flex-direction: column; overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .45);
  animation: psg-in .2s cubic-bezier(.4, 0, .2, 1);
}
@keyframes psg-in {
  from { opacity: 0; transform: scale(.93) translateY(10px); }
  to   { opacity: 1; transform: none; }
}

/* ── Header ── */
.psg-head {
  display: flex; align-items: center; justify-content: space-between;
  padding: 14px 18px; border-bottom: 1px solid var(--border); flex-shrink: 0;
}
.psg-head-left { display: flex; align-items: center; gap: 10px; }
.psg-head-icon {
  width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0;
  background: color-mix(in srgb, var(--accent) 15%, transparent);
  color: var(--accent); font-size: 17px;
  display: flex; align-items: center; justify-content: center;
}
.psg-head-txt { display: flex; flex-direction: column; line-height: 1.3; }
.psg-head-txt span { font-size: 14px; font-weight: 800; color: var(--text); }
.psg-head-txt small { font-size: 11px; color: var(--text2); }
.psg-close {
  background: none; border: none; color: var(--text2); font-size: 20px;
  cursor: pointer; line-height: 1; padding: 4px; border-radius: 6px;
  transition: color .12s;
}
.psg-close:hover { color: var(--red); }

/* ── Body ── */
.psg-body {
  padding: 16px 18px; display: flex; flex-direction: column; gap: 12px;
  overflow-y: auto;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}

/* ── Alertes ── */
.psg-alert {
  display: flex; align-items: flex-start; gap: 8px;
  padding: 10px 12px; border-radius: 9px;
  font-size: 12px; line-height: 1.45;
}
.psg-alert i { font-size: 15px; flex-shrink: 0; margin-top: 1px; }
.psg-alert-warn {
  background: color-mix(in srgb, var(--amber) 12%, transparent);
  border: 1px solid var(--amber); color: var(--amber);
}
.psg-alert-err {
  background: color-mix(in srgb, var(--red) 12%, transparent);
  border: 1px solid var(--red); color: var(--red);
}

/* ── Tableau ── */
.psg-table-wrap {
  border: 1px solid var(--border); border-radius: 10px; overflow: auto;
  scrollbar-width: thin; scrollbar-color: var(--border) transparent;
}
.psg-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.psg-table thead th {
  position: sticky; top: 0; z-index: 1;
  background: var(--surface2); color: var(--text2);
  font-size: 11px; font-weight: 800; text-transform: uppercase; letter-spacing: .4px;
  padding: 9px 10px; text-align: left; border-bottom: 1px solid var(--border);
  white-space: nowrap;
}
.psg-table tbody td {
  padding: 9px 10px; border-bottom: 1px solid var(--border);
  color: var(--text); vertical-align: middle;
}
.psg-table tbody tr:last-child td { border-bottom: none; }
.psg-th-chk { width: 38px; text-align: center !important; }
.psg-th-chk input { width: 16px; height: 16px; cursor: pointer; accent-color: var(--accent); }
.psg-th-chk input:disabled { cursor: not-allowed; opacity: .4; }
.psg-num { text-align: right !important; white-space: nowrap; }
.psg-qte { font-weight: 800; }
.psg-total-l { font-weight: 800; color: var(--text); }

.psg-tr-err { background: color-mix(in srgb, var(--red) 8%, transparent); }
.psg-tr-off { opacity: .45; }

.psg-lib { font-weight: 700; line-height: 1.3; }
.psg-lib-err { color: var(--red); display: flex; align-items: center; gap: 5px; }
.psg-badges { display: flex; align-items: center; gap: 6px; flex-wrap: wrap; margin-top: 3px; }
.psg-ean { font-family: ui-monospace, 'Consolas', monospace; font-size: 10px; color: var(--text3); }
.psg-badge {
  display: inline-flex; align-items: center; gap: 3px;
  font-size: 10px; font-weight: 700; padding: 2px 6px; border-radius: 5px;
  border: 1px solid currentColor;
}
.psg-badge-warn { color: var(--amber); }
.psg-vide { text-align: center; color: var(--text3); padding: 24px !important; }

/* ── Récapitulatif ── */
.psg-recap {
  background: var(--surface2); border: 1px solid var(--border);
  border-radius: 10px; padding: 12px 14px;
  display: flex; flex-direction: column; gap: 6px;
}
.psg-recap-row {
  display: flex; align-items: center; justify-content: space-between;
  font-size: 12px; color: var(--text2);
}
.psg-recap-row strong { color: var(--text); font-weight: 800; }
.psg-recap-main {
  border-top: 1px dashed var(--border); padding-top: 8px; margin-top: 2px;
  font-size: 13px; font-weight: 800; color: var(--text);
}
.psg-recap-main strong { font-size: 19px; color: var(--green); }
.psg-recap-note {
  display: flex; align-items: flex-start; gap: 5px;
  font-size: 10.5px; color: var(--text3); line-height: 1.4;
}

/* ── Footer ── */
.psg-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 14px 18px; border-top: 1px solid var(--border); flex-shrink: 0;
}
.psg-btn-sec {
  padding: 9px 16px; border-radius: 8px;
  background: var(--surface2); border: 1px solid var(--border);
  color: var(--text2); font-size: 13px; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: all .12s;
}
.psg-btn-sec:hover { border-color: var(--red); color: var(--red); }
.psg-btn-pri {
  display: flex; align-items: center; gap: 6px;
  padding: 9px 20px; border-radius: 8px; border: none;
  background: var(--accent); color: #fff; font-size: 13px; font-weight: 700;
  cursor: pointer; font-family: inherit; transition: opacity .12s;
}
.psg-btn-pri:hover:not(:disabled) { opacity: .88; }
.psg-btn-pri:disabled { opacity: .4; cursor: not-allowed; }

/* ── Mobile bottom-sheet ── */
@media (max-width: 640px) {
  .psg-overlay { align-items: flex-end; padding: 0; }
  .psg-dialog {
    width: 100%; max-height: 94vh; border-radius: 16px 16px 0 0;
    animation: psg-slide-up .25s cubic-bezier(.4, 0, .2, 1);
  }
  .psg-table { font-size: 12px; }
}
@keyframes psg-slide-up {
  from { transform: translateY(100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
}
</style>
